import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=58f95ed4&"
import script from "./MyDialog.vue?vue&type=script&lang=ts&"
export * from "./MyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MyDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports